
<template>
  <div class="palette-sample-list">
    <a class="item" v-for="(number, index) in (numberOfCards > items.length ? items.length : numberOfCards)" :key="index" @click="handlePreview(index)">
      <img :src="items[index].url" alt=""/>
    </a>

    <a class="item empty placeholder" v-for="(_, i) in placeholders" :key="i">
      <div class="inner">
        <div class="content">
          <i class="material-icons"></i>
        </div>
      </div>
    </a>

    <div class="item empty" @click="handleHint">
      <img src="../../assets/hint4.png" alt=""
           class="hint hidden-tablet"
           :class="{active: showHint && !hintShown}"
      />

      <a @click="onUIClick" class="inner">
        <div class="content">
          <div class="text">+{{totalNumberOfStyleRules - numberOfCards > 0 ? totalNumberOfStyleRules - numberOfCards : 0}}</div>
          <i class="material-icons">arrow_forward</i>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '../../utils/session';

export default {
  name: 'palette-sample-list',
  props: {
    showHint: Boolean,
    items: Array,
    totalNumberOfStyleRules: Number,
    colors: String,
    onUIClick: Function,
    handlePreview: Function,
  },
  data() {
    return {
      numberOfCards: 10,
      placeholders: new Array(10),
      hintShown: getSession('enterHintShown'),
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleNumberOfCards();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.handleNumberOfCards();
    },
    handleNumberOfCards() {
      const width = window.innerWidth;
      if (width > 2500 && width <= 3200) {
        this.numberOfCards = 10;
      } else if (width > 1921) {
        this.numberOfCards = 9;
      } else if (width > 1801) {
        this.numberOfCards = 8;
      } else if (width > 1200) {
        this.numberOfCards = 7;
      } else if (width > 990) {
        this.numberOfCards = 6;
      } else if (width > 767) {
        this.numberOfCards = 4;
      } else if (width > 480) {
        this.numberOfCards = 5;
      } else {
        this.numberOfCards = 5;
      }
    },
    handleHint() {
      this.hintShown = true;
      setSession('enterHintShown', true);
    },
  },
  watch: {
    numberOfCards(to) {
      const lockNumber = to - this.items.length;
      this.placeholders = new Array(lockNumber > 0 ? lockNumber : 0);
    },
    items(to) {
      const lockNumber = this.numberOfCards - to.length;
      this.placeholders = new Array(lockNumber > 0 ? lockNumber : 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .palette-sample-list {
    display: flex;
    flex-flow: row wrap;
    margin: 0 -12px;

    @include media($smallMobile) {
      margin: 0 -8px;
    }
  }

  .item {
    padding: 0 12px;
    margin-bottom: 25px;
    width: 10%;
    min-height: 150px;
    position: relative;

    &.placeholder {
      pointer-events: none;
    }

    @include media($hdDesktop3) {
      width: 9.091%;

      &.placeholder:nth-child(11) {
        display: none;
      }
    }

    @include media($hdDesktop2) {
      width: 10%;

      &.placeholder:nth-child(10) {
        display: none;
      }
    }

    @include media($hdDesktop) {
      width: 11.1111%;

      &.placeholder:nth-child(9) {
        display: none;
      }
    }

    @include media($mediumDesktop) {
      width: 12.5%;

      &.placeholder:nth-child(8) {
        display: none;
      }
    }

    @include media($smallDesktop) {
      width: 14.2857%;

      &.placeholder:nth-child(7) {
        display: none;
      }
    }

    @include media($tablet) {
      width: 20%;

      &.placeholder:nth-child(5), &.placeholder:nth-child(7), &.placeholder:nth-child(8), &.placeholder:nth-child(9) {
        display: flex;
      }
    }

    @include media($mobile) {
      width: 33.3333%;

      &.placeholder:nth-child(5), &.placeholder:nth-child(6), &.placeholder:nth-child(7), &.placeholder:nth-child(8) {
        display: none;
      }
    }

    @include media($smallMobile) {
      width: 50%;
      padding: 0 8px;
      margin-bottom: 15px;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .empty {
    display: flex;
    padding: 0 12px;

    @include media($smallMobile) {
      padding: 0 8px;
    }

    .inner {
      background: $bg2;
      display: flex;
      align-items: center;
      font-weight: 500;
      width: 100%;

      @include media($tablet) {
        min-height: 150px;
      }

      @include media($mobile) {
        min-height: 220px;
      }
    }

    .content {
      position: relative;
      text-align: center;
      width: 100%;
    }

    .text {
      font-size: 18px;
      position: absolute;
      top: -30px;
      left: 0;
      width: 100%;
    }

    i {
      font-size: 40px;
    }

    .hint {
      position: absolute;
      left: 50%;
      bottom: 100%;
      width: auto;
      height: 135%;
      max-width: none;
      opacity: 0;
      pointer-events: none;
      transform: translate(-50%, 20px);
      transition: $transition;

      &.active {
        opacity: 1;
        pointer-events: auto;
        transform: translate(-50%, 0);
      }
    }
  }
</style>
